import { FactoryNodeInterfaceParameterBehaviorType } from "../enums/factory-node-interface-parameter-behavior-type.enum";
import { FactoryNodeInterfaceConfig } from "../models/factory-node-interface-config.model";

export function generateFactoryNodeInterfaceDefinition(interfaceConfig: FactoryNodeInterfaceConfig): string {

    let body = "";

    body += `export interface ${interfaceConfig.name} { // ${interfaceConfig.description}\n`;

    interfaceConfig.parameters.forEach((parameter) => {

        let type : string = parameter.type;

        if(parameter.isArray) {
            type += "[]";
        }

        if(parameter.behavior !== FactoryNodeInterfaceParameterBehaviorType.Standard) {
            type = `${parameter.behavior}<${type}>`
        }


        body += `    ${parameter.name}: ${type}; // ${parameter.description}\n`;
    });

    body += `}\n`;

    return body;
}